/**
 * Whether a background refresh may replace what is on screen.
 *
 * Stale-while-revalidate paints a cached record, then overwrites it when the
 * server answers. If someone started typing in between, that second write
 * destroys their edits — silently, because it looks like a load rather than
 * a change. Worse, it also resets the dirty baseline, so the guard then
 * believes nothing was edited and will not warn on the way out.
 *
 * The refresh is for a person who has not touched the form. Once they have,
 * what they typed outranks what the server last said.
 */
export const mayApplyRefresh = (
  baseline: string | null,
  currentSerialised: string,
): boolean => {
  // Nothing loaded yet — this IS the load.
  if (baseline === null) return true;
  // Untouched since it loaded: refreshing is free.
  return currentSerialised === baseline;
};
